const t = "container_2FcJe", n = "title_p5OPy", e = "subtitle_tlfp2", o = "button_qoErM", s = {
  container: t,
  title: n,
  subtitle: e,
  button: o
};
export {
  o as button,
  t as container,
  s as default,
  e as subtitle,
  n as title
};
//# sourceMappingURL=duplicatePhoneError.module.scss.js.map
